module.exports = "<dropdown :open.sync=show :options=fdata.options :callback=select :active=active :disabled=!fdata.editable><dynamic-input slot=Dropdown__field :model=selected.label :schema=input :callbacks=callbacks :disabled=!fdata.editable></dynamic-input></dropdown><div v-if=errors transition=fade style=\"margin: -1em 1em 0\" class=\"Error animated\"> <p class=Error__msg>{{ errors }} </p></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/selects/custom-select.vue
// module id = 452
// module chunks = 0